import { useMemo } from "react";
import { ListCategoryDto } from "../models/categories.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredCategories(categories: ListCategoryDto[]) {
	const { query } = useSearch();

	const filteredCategories = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return categories?.filter(cat => 
				(cat.Title && cat.Title.toLowerCase().includes(lowerQuery))) || [];
		} else {
			return categories || [];
		}
	}, [query, categories]);

	return { filteredCategories, showNoResults: query && query.length > 0 && filteredCategories.length === 0 };
}